import React from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {noop} from 'lodash';
import PropTypes from 'prop-types';

import LoadingIndicator from '/component/base/LoadingIndicator';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {OrderDetails} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import testProperties from '/util/testing/testProperties';

import AddressesSection from './AddressesSection';
import {styles} from './OrderDetail.style';
import OrderSection from './OrderSection';
import ShipmentSection from './ShipmentSection';
import SummarySection from './SummarySection';

export class OrderDetail extends React.PureComponent {
  requestedOrderId: string | number | null = null;

  requestedProfileId: string | number | null = null;

  constructor(...args: any[]) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super(...args);
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    this.requestDataIfNeeded();
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: any) {
    const {orderId, hasOrder, hasCustomer, customerId, isLoading} = this.props;

    if (prevProps.orderId !== orderId) {
      this.requestedOrderId = null;
      this.requestedProfileId = null;
      this.requestDataIfNeeded();
      return;
    }

    if (
      prevProps.hasOrder !== hasOrder ||
      prevProps.hasCustomer !== hasCustomer ||
      prevProps.customerId !== customerId ||
      prevProps.isLoading !== isLoading
    ) {
      this.requestDataIfNeeded();
    }
  }

  requestDataIfNeeded() {
    const {
      // @ts-expect-error TS(2339): Property 'fetchData' does not exist on type 'Reado... Remove this comment to see the full error message
      fetchData,
      // @ts-expect-error TS(2339): Property 'orderId' does not exist on type 'Readonly<{}>'
      orderId,
      // @ts-expect-error TS(2339): Property 'hasOrder' does not exist on type 'Readonly<{}>'
      hasOrder,
      // @ts-expect-error TS(2339): Property 'hasCustomer' does not exist on type 'Readonly<{}>'
      hasCustomer,
      // @ts-expect-error TS(2339): Property 'customerId' does not exist on type 'Readonly<{}>'
      customerId,
      // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'Readonly<{}>'
      isLoading,
    } = this.props;

    if (isLoading || !orderId) {
      return;
    }

    if (!hasOrder) {
      if (this.requestedOrderId !== orderId) {
        this.requestedOrderId = orderId;
        this.requestedProfileId = null;
        fetchData();
      }
      return;
    }

    if (!hasCustomer && customerId) {
      if (this.requestedProfileId !== customerId) {
        this.requestedProfileId = customerId;
        fetchData();
      }
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {
      // @ts-expect-error TS(2339): Property 'tt' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
      tt,
      // @ts-expect-error TS(2339): Property 'style' does not exist on type 'Readonly<... Remove this comment to see the full error message
      style: styleProp,
      // @ts-expect-error TS(2339): Property 'orderId' does not exist on type 'Readonl... Remove this comment to see the full error message
      orderId,
      // @ts-expect-error TS(2339): Property 'hasData' does not exist on type 'Readonl... Remove this comment to see the full error message
      hasData,
      // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'Reado... Remove this comment to see the full error message
      isLoading,
      // @ts-expect-error TS(2339): Property 'onViewProfile' does not exist on type 'R... Remove this comment to see the full error message
      onViewProfile,
      // @ts-expect-error TS(2339): Property 'onViewOrderHistory' does not exist on type 'Readonly<...>'
      onViewOrderHistory,
      // @ts-expect-error TS(2339): Property 'orderNumber' does not exist on type 'Rea... Remove this comment to see the full error message
      orderNumber,
      // @ts-expect-error TS(2339): Property 'hideHeadingOnWeb' does not exist on type 'Readonly<...>'
      hideHeadingOnWeb,
    } = this.props;
    const style = [styles.base];
    style.push(styleProp.base);

    return !hasData || isLoading ? (
      <View style={styles.loading}>
        <LoadingIndicator size="large" style={styles.loadingIndicator} />
      </View>
    ) : (
      <View style={style}>
        {Platform.OS !== 'web' || !hideHeadingOnWeb ? (
          <View style={styles.heading}>
            <Gutter>
              {tt(
                'heading',
                generateComponentCallback({
                  component: (
                    <View
                      style={styles.orderNumberContainer}
                      {...testProperties(OrderDetails.numberOfOrder)}>
                      <Text
                        variant="large"
                        testID={OrderDetails.numberOfOrderLabel}>
                        Order #
                      </Text>
                      <Text
                        variant="large"
                        testID={OrderDetails.numberOfOrderValue}>
                        {orderNumber}
                      </Text>
                    </View>
                  ),
                }),
              )}
            </Gutter>
          </View>
        ) : null}
        {Platform.OS === 'web' ? (
          <View style={styles.webScrollContainer as any}>
            <View style={styles.sections}>
              <OrderSection
                orderId={orderId}
                onViewProfile={onViewProfile}
                onViewOrderHistory={onViewOrderHistory}
              />
              <ShipmentSection orderId={orderId} />
              <AddressesSection orderId={orderId} />
              <SummarySection orderId={orderId} />
            </View>
          </View>
        ) : (
          <ScrollView>
            <View style={styles.sections}>
              <OrderSection
                orderId={orderId}
                onViewProfile={onViewProfile}
                onViewOrderHistory={onViewOrderHistory}
              />
              <ShipmentSection orderId={orderId} />
              <AddressesSection orderId={orderId} />
              <SummarySection orderId={orderId} />
            </View>
          </ScrollView>
        )}
      </View>
    );
  }
}

// @ts-expect-error TS(2339): Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
OrderDetail.propTypes = {
  tt: PropTypes.func,
  style: PropTypes.object,
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasData: PropTypes.bool,
  hasOrder: PropTypes.bool,
  hasCustomer: PropTypes.bool,
  customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  fetchData: PropTypes.func,
  onViewProfile: PropTypes.func,
  onViewOrderHistory: PropTypes.func,
  orderNumber: PropTypes.string,
  hideHeadingOnWeb: PropTypes.bool,
};

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
OrderDetail.defaultProps = {
  tt: withTranslation.ttDefaultProp,
  style: {},
  orderId: '',
  hasData: false,
  hasOrder: false,
  hasCustomer: false,
  customerId: null,
  isLoading: false,
  fetchData: noop,
  onViewProfile: noop,
  onViewOrderHistory: noop,
  orderNumber: '',
  hideHeadingOnWeb: false,
};

export default withTranslation('screen.orderDetail')(OrderDetail);
